import React, { Fragment } from 'react'

// icons
import { faLayerGroup } from '@fortawesome/free-solid-svg-icons'

// components
import Header from '../Header/Header'
import BotonBack from '../Utiles/BotonBack'
import Subtitulo from '../Utiles/Subtitulo'
import ItemDepartamento from './ItemDepartamento'

// route
import { withRouter } from 'react-router-dom'


// alert swal
import routes from '../../Routes'
import HeaderActionsButtons from '../Custom/HeaderActionsButtons'
import HeaderPagination from '../Custom/HeaderPagination'
import useDepartment from './hooks/useDepartment'
import usePagination from './hooks/usePagination'
const visibleButtons = {
    create: true,
    import: true,
    export: true,
    deleted: true,
    search: true,
}

const Departamentos = ({ history }) => {
    const {
        page,
        totalRegister,
        totalPage,
        departamentos,
        nextPage,
        previousPage,
        handleBuscador,
        setIsLoad
    } = usePagination(history)

    const { handleImprimir, eliminarDepartamento } = useDepartment(history)

    return (
        <Fragment>
            <Header />
            <div className="container-fluid mt-3">
                <div className="alert alert-dismissible alert-secondary d-flex justify-content-between">
                    <BotonBack />
                    <Subtitulo icon={faLayerGroup} title={'Departamentos'} />
                </div>

                <HeaderActionsButtons
                    history={history}
                    routes={routes.DEPARTAMENTO}
                    visibleButtons={visibleButtons}
                    handleImprimir={handleImprimir}
                    handleBuscador={handleBuscador}
                />
                <HeaderPagination
                    page={page}
                    totalPage={totalPage}
                    previousPage={previousPage}
                    nextPage={nextPage}
                    totalRegister={totalRegister}
                />

                <table className="table table-striped mt-3 text-center">
                    <thead>
                        <tr>
                            <th scope="col">Codigo</th>
                            <th scope="col">Nombre</th>
                            <th scope="col">IVA</th>
                            <th scope="col">Acciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        {departamentos.map((departamento) => (
                            <ItemDepartamento
                                key={parseInt(departamento.id)}
                                departamento={departamento}
                                eliminarDepartamento={eliminarDepartamento}
                                setIsLoad={setIsLoad}
                            />
                        ))}
                    </tbody>
                </table>
            </div>
        </Fragment>
    )
}

export default withRouter(Departamentos)
